import RelatedItems from '../../../../../components/RelatedItems/RelatedItems';

export default RelatedItems;
